import axios from "axios";
import { BaseURL } from "../../Essentials/variables";

const api = axios.create({
  baseURL: BaseURL
});

export const sendOTP = async (username) => {
  try {
    const response = await api.post("/dealer/sendOtp", {
      username,
    });

    if (!response?.data) {
      throw new Error("Empty response from dealer otp send API");
    }

    const otpMessage = response.data?.message;

    if (typeof otpMessage !== "string" || !otpMessage) {
      throw new Error("Invalid redirect URL received");
    }

    return otpMessage;
  } catch (error) {
    throw new Error("Unable to initiate Dealer otp Send");
  }
};



export const verifyOTP = async (username,otp) => {
  try {
    const response = await api.post("/dealer/verifyOtp", {
      username,
      otp
    });

    const data = response.data?.message;
    return data;
  } catch (error) {
    throw new Error("Unable to verify OTP");
  }
};


